// extracted by mini-css-extract-plugin
module.exports = {"info":"CovidUserInfo_info__urMG4","detail":"CovidUserInfo_detail__Y9Rc2"};